import { render, staticRenderFns } from "./SelectComunidad.vue?vue&type=template&id=1da4bf68"
import script from "./SelectComunidad.vue?vue&type=script&lang=js"
export * from "./SelectComunidad.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports